/**
 * Used to check environment condition. Change environment condition by add specific key to localStorage.
 * @param key - key to check in localStorage(default is 'debug' if not specified)
 *  */
export const isDebug = (key = 'debug') => localStorage.getItem(key) !== null;
